
import { CustomerAttachmentsState } from "../interfaces/customerAttachment"
import { Types } from "../types"
import { CustomerAttachmentsActions } from "../types/customerAttachments/actionsTypes"



const initialState: CustomerAttachmentsState = {

    getCustomerAttachmentsPending: false,
    getCustomerAttachmentsSuccess: false,
    getCustomerAttachmentsError: '',
    customerAttachments: [],


    saveCustomerAttachmentsPending: false,
    saveCustomerAttachmentsSuccess: false,
    saveCustomerAttachmentsError: '',

    deleteCustomerAttachmentsPending: false,
    deleteCustomerAttachmentsSuccess: false,
    deleteCustomerAttachmentsError: '',
    deleteStatus: false,

    getCustomerAttachmentByIdsPending: false,
    getCustomerAttachmentByIdsSuccess: false,
    getCustomerAttachmentByIdsError: '',
    url: '',
    contentType: ''

}


const customerAttachmentsReducer = (state = initialState, action: CustomerAttachmentsActions) => {
    switch (action.type) {

        //Get************************************************************************************************

        case Types.GET_ATTACHMENT_REQUEST:
            return {
                ...state,
                getCustomerAttachmentsPending: true,
                getCustomerAttachmentsSuccess: false,
                getCustomerAttachmentsError: '',
            }
        case Types.GET_ATTACHMENT_SUCCESS:
            return {
                ...state,
                getCustomerAttachmentsPending: false,
                getCustomerAttachmentsSuccess: true,
                getCustomerAttachmentsError: '',
                customerAttachments: action.payload.params
            }
        case Types.GET_ATTACHMENT_ERROR:
            return {
                ...state,
                getCustomerAttachmentsPending: false,
                getCustomerAttachmentsSuccess: false,
                getCustomerAttachmentsError: action.payload,
            }

        //Save*************************************************************************************************

        case Types.SAVE_ATTACHMENT_REQUEST:
            return {
                ...state,
                saveCustomerAttachmentsPending: true,
                saveCustomerAttachmentsSuccess: false,
                saveCustomerAttachmentsError: ''
            }

        case Types.SAVE_ATTACHMENT_SUCCESS:
            return {
                ...state,
                saveCustomerAttachmentsPending: false,
                saveCustomerAttachmentsSuccess: true,
                saveCustomerAttachmentsError: '',
            }

        case Types.SAVE_ATTACHMENT_ERROR:
            return {
                ...state,
                saveCustomerAttachmentsPending: false,
                saveCustomerAttachmentsSuccess: false,
                saveCustomerAttachmentsError: action.payload
            }
        //Delete**************************************************************************************************
        case Types.DELETE_ATTACHMENT_REQUEST:
            return {
                ...state,
                deleteCustomerAttachmentsPending: true,
                deleteCustomerAttachmentsSuccess: false,
                deleteCustomerAttachmentsError: '',
                deleteStatus: false
            }

        case Types.DELETE_ATTACHMENT_SUCCESS:
            return {
                ...state,
                deleteCustomerAttachmentsPending: false,
                deleteCustomerAttachmentsSuccess: true,
                deleteCustomerAttachmentsError: '',
                deleteStatus: action.payload.params
            }

        case Types.DELETE_ATTACHMENT_ERROR:
            return {
                ...state,
                deleteCustomerAttachmentsPending: false,
                deleteCustomerAttachmentsSuccess: false,
                deleteCustomerAttachmentsError: action.payload,
                deleteStatus: false
            }
        //Get by id***********************************************************************************************
        case Types.GET_ATTACHMENT_BY_ID_REQUEST:
            return {
                ...state,
                getCustomerAttachmentByIdsPending: true,
                getCustomerAttachmentByIdsSuccess: false,
                getCustomerAttachmentByIdsError: '',
                url: '',
                contentType: ''
            }

        case Types.GET_ATTACHMENT_BY_ID_SUCCESS:
            return {
                ...state,
                getCustomerAttachmentByIdsPending: false,
                getCustomerAttachmentByIdsSuccess: true,
                getCustomerAttachmentByIdsError: '',
                url: action.payload?.params?.DataUrlContent,
                contentType: action.payload?.params?.ContentType
            }

        case Types.GET_ATTACHMENT_BY_ID_ERROR:
            return {
                ...state,
                getCustomerAttachmentByIdsPending: false,
                getCustomerAttachmentByIdsSuccess: false,
                getCustomerAttachmentByIdsError: '',
                url: '',
                contentType: ''
            }
        //Rset****************************************************************************************************

        case Types.SET_RESET_ATTACHMENT_PROPS:
            return {

                ...state,

                getCustomerAttachmentsPending: false,
                getCustomerAttachmentsSuccess: false,
                getCustomerAttachmentsError: '',
                // customerAttachments: [],

                saveCustomerAttachmentsPending: false,
                saveCustomerAttachmentsSuccess: false,
                saveCustomerAttachmentsError: '',

                deleteCustomerAttachmentsPending: false,
                deleteCustomerAttachmentsSuccess: false,
                deleteCustomerAttachmentsError: '',
                deleteStatus: false,

                getCustomerAttachmentByIdsPending: false,
                getCustomerAttachmentByIdsSuccess: false,
                getCustomerAttachmentByIdsError: '',
                url: '',
                contentType: ''

            }
        //***************************************************************************************************** */    
        default:
            return {
                ...state
            }
    }
}

export default customerAttachmentsReducer